
import React, {Component} from 'react'
import Stencil from './Stencil';
import { Button } from 'reactstrap';

var constants = require('../../utils/domain/constants');
var translator = require('../../utils/translator/translator');
var floorLayoutUtil = require('../../utils/domain/floorLayoutUtil');

class Floor extends Component 
{

    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.floors = floorLayoutUtil.getFloors();

        this.state.selectedFloor = null;
        if (this.state.floors.length > 0)
            this.state.selectedFloor = this.state.floors[0];
        
    }

    render()
    {
        return <div className='h-100'>
                    {this.renderToolbar()}
                    {this.renderBody()}
                </div>
    }

    renderToolbar()
    {
        if (this.state.floors.length <= 1)
            return null;

        return <div className='position-relative'>
                    <div style={{position:'absolute',right:10,top:10,zIndex:1}}>
                        <nav style={{
                                    position: "relative",
                                    }}>

                                        <div
                                            style={{
                                                display: "flex",
                                            }}
                                        >
                            {this.state.floors.map((floor) => {
                                return (
                                <Button
                                    className={`btn-nav ${this.state.selectedFloor === floor && "selected"} `}
                                    style={{whiteSpace:'nowrap', minWidth:"var(--button-width)"}}
                                    onClick={()=>
                                    {
                                        this.state.selectedFloor = floor;
                                        this.setState({});
                                    }}
                                >
                                    {floor.title}
                                </Button>
                                );
                            })}
                            </div>
                        </nav>
                    </div>
                </div>
    }

    renderBody()
    {
        return (
                <div className='grid-dots overflow-auto' style={{position:'relative', height:'100%', padding:"9vh 20px 0px 20px", borderBottom:"20px solid transparent" }}>
                            {this.renderFloor()}
                </div>
        )
    }

    renderFloor()
    {
        if (this.state.selectedFloor == null ||
            this.state.selectedFloor.stencils == null ||
            this.state.selectedFloor.stencils.filter(s => s.type == constants.floorStencilType.Seating).length <= 0)
        {
            return <div className='caption primary-color d-flex flex-column justify-content-center align-items-center' style={{marginTop:'20vh'}}>
                            <div>
                                {translator.getLabel("no_seatings_found")}   
                            </div>                            
                    </div>
        }
            

        let components = [];

        this.state.selectedFloor.stencils.forEach (stencil =>
        {
            if (stencil.type != constants.floorStencilType.Seating)
                return;

            components.push(
                                <Stencil stencil={stencil} 
                                         onStencilClick={this.props.onStencilClick}
                                         isStencilEnabled={this.props.isStencilEnabled} 
                                         isStencilSelected={this.props.isStencilSelected}/>
                            );
        })

        return components;
    }

    
}

export default Floor;